import React, { useRef } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SortRow from './Row';

import { useTbodyPosition } from '../../../../../../utils/hooks/useTbodyPosition';

const Body = ({ isLoading, items, access, onEdit }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '300px' });

  return (
    <tbody
      className={classNames('signup-list__container', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: '56%' }}
      ref={bodyRef}
    >
      {items?.map((item, idx) => (
        <SortRow
          key={`row-${idx}`}
          index={idx}
          collection={item?.is_default ? 1 : 0}
          item={item}
          access={access}
          onEdit={onEdit}
        />
      ))}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  access: PropTypes.object,
  onEdit: PropTypes.func,
};

export default SortableContainer(Body);
